import axios from "axios";
export default {
	inject: ["openShowModalLoading", "closeShowModalLoading"],
	data() {
		/*QUESTO MIXINS E' STATO FATTO DA SISTO, NON SONO STATI IMPLEMENTATI I METODI PER IL LOAD DEL PRESIDIO, 
        MA SOLO QUELLI CHE CARICANO I PRESIDI DELL'UTENTE PERCHE' MI SERVIVANO QUELLI*/
		return {
			assistiti: [],
			assistitiPerPage: 50,
			assistitiCurrentPage: 1,
			assistitiPathResource: "/rsagestioneassistiti",
			assistitiRecordsNumber: 0,
		};
	},
	methods: {
		loadAssistiti(page, afterLoad = null) {
			this.openShowModalLoading();
			let me = this;
			me.assistitiCurrentPage = page ? page : 1;
			let sessionStorage = window.sessionStorage;
			let filtroGestioneAssistiti = sessionStorage.getItem("filtroGestioneAssistiti");
			let filtro = filtroGestioneAssistiti ? JSON.parse(filtroGestioneAssistiti) : {};
			let link = process.env.VUE_APP_PATH_API + me.assistitiPathResource;
			filtro.page = this.assistitiCurrentPage;
			filtro.forPage = this.assistitiPerPage;
			axios.get(link, { params: filtro })
				.then((response) => {
					this.assistitiRecordsNumber = response.data.data.recordsNumber;
					this.assistiti = response.data.data.list;
					if (afterLoad != null) {
						afterLoad();
					}
					this.closeShowModalLoading();
				})
				.catch((error) => {
					this.closeShowModalLoading();
					this.$bvToast.toast("Errore nel leggere dati: " + error.message, {
						title: "",
						variant: "danger",
						solid: true,
					});
				});
		},
	},
};
